<template>
  <div class="join-us-background">
    <div class="join-us-banner">
      <div class="join-us-container">
        <div class="join-us-banner-title">加入我们</div>
      </div>

      <img class="join-us-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="join-us-container">

     <div class="join-us-content">
       <div class="join-us-content-title">
         <div class="join-us-content-title-text">招贤纳士</div>
       </div>
       <div class="join-us-content-info">
         <p class="join-us-content-info-text">几年来通过不断推出和完善适应市场的优秀产品和优质服务，“龙讯”已经成功在材料模拟计算软件之中占据一席之地。为了提供国内乃至国际上一流的高性能材料模拟计算服务，推动国产材料模拟计算软件的发展，现诚邀广大志同道合之士加入龙讯这个大家庭。（本招聘长期有效）</p>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">开发工程师</div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">职位需求</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>计算数学、固体物理、凝聚态物理、半导体、材料等相关专业</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>硕士研究生及以上学历</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>物理基础扎实，熟悉固体能带理论、密度泛函理论</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>熟练使用PWmat/VASP/QE计算能带和态密度并在英文期刊发表过相关文章</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>掌握Python/Fortran/C/C++等语言的一种或者几种，基于PWmat/VASP/QE等计算软件编写过Python/Fortran/C/C++后处理程序</div>
         </div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">职位描述</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>基于PWmat的输入和输出编写相关功能的前处理和后处理Python/Fortran/C/C++脚本</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>理解客户的需求，按照客户的要求编写基于PWmat的功能模块</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>编写脚本的技术说明文档，方便用户快速掌握脚本的使用</div>
         </div>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">销售岗位客户经理</div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">职位需求</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>物理、材料以及半导体等相关专业，本科及以上学历</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>认识路，方位感好，会开车优先</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>普通话标准，说话流利</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>在校期间给老师办理过科研经费报销手续的优先</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>会使用DFT软件并且发表过相关文章的优先考虑</div>
         </div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">职位描述</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>新客户发展以及老客户跟进</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>公司软件产品的推广和销售</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>制定销售计划，完成销售计划</div>
         </div>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">薪酬福利</div>
         <div class="join-us-position-require">
           <div class="join-us-position-require-text">年薪不低于25万（税前），销售另议</div>
           <div class="join-us-position-require-text">五险一金，带薪休假</div>
           <div class="join-us-position-require-text">额外的饭补、出差补助、入职电脑购置补助</div>
           <div class="join-us-position-require-text">公司出资，报名参加深度学习AI培训</div>
         </div>
       </div>
       <div class="join-us-position">
         <div class="join-us-position-name">公司优势</div>
         <div class="join-us-position-require">
           <div class="join-us-position-require-text">与IT公司相比，作为理论计算的硕士，龙讯旷腾更能发挥你的专业优势，同时工作强度不大，绝对不是996</div>
           <div class="join-us-position-require-text">搞计算，写程序，本行不丢，未来转互联网企业很容易</div>
           <div class="join-us-position-require-text">初创公司，早来早占坑，早拿股份，早带团队</div>
           <div class="join-us-position-require-text">成为精通物理和计算机的复合人才，通过我司培训迅速掌握一区期刊发文章套路</div>
         </div>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">简历投递</div>
         <div class="join-us-position-require">
           <div class="join-us-position-require-text">投递邮箱：zhaopin@pwmat.com</div>

         </div>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .join-us-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .join-us-background{
    margin-top: 70px;
  }
  .join-us-banner{
    overflow:hidden;
  }
  .join-us-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .join-us-banner-img{
    min-width:100%;
    height:165px;
  }
  .join-us-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .join-us-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .join-us-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .join-us-content-info{
    margin-top: 50px;
  }
  .join-us-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .join-us-position{
    padding-top: 18px;
  }
  .join-us-position-name{
    color:rgba(73,145,201,1);
    font-size:22px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    line-height:50px;
  }
  .join-us-position-title{
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    line-height:50px;
  }
  .join-us-position-require-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 8px;
  }
  .fa-join-us-position{
    margin-right: 8px;
  }
  @media screen and (max-width:482px) {
    .join-us-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .join-us-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .join-us-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .join-us-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .join-us-container{
      max-width: 1068px;
    }
  }

</style>
